module.exports = __webpack_public_path__ + "static/Hero-b6e0e34d0ced9c704295327eb7a40d88.jpg";